module.exports = __webpack_public_path__ + "static/media/liverbird.8bb57dd8.gif";